import moment from 'moment'

export const cardColors = ['#4A8DC0', '#65BF73', '#2C998C', '#C03261']

export const LBF_QUERY_KEY = {
  QSF_FILTER_CATEGORY: 'QSF_FILTER_CATEGORY',
  QSF_CHART_DATA: 'QSF_CHART_DATA',
  QSF_SCORECARD: 'QSF_SCORECARD',
  QSF_SWITCH_SCORECARD: 'QSF_SWITCH_SCORECARD',
  PRODUCT_FILTER_CATEGORY: 'PRODUCT_FILTER_CATEGORY',
}

export const LBF_DATE_PICKER = [
  {
    key: 'last_7_days',
    value: 'Last 7 days',
    date: [moment().subtract(6, 'd').startOf('day'), moment().endOf('day')],
  },
  {
    key: 'last_30_days',
    value: 'Last 30 days',
    date: [moment().subtract(29, 'd').startOf('day'), moment().endOf('day')],
  },
  {
    key: 'last_90_days',
    value: 'Last 90 days',
    date: [moment().subtract(89, 'd').startOf('day'), moment().endOf('day')],
  },
  {
    key: 'this_month',
    value: 'This month',
    date: [moment().startOf('month'), moment().endOf('day')],
  },
  {
    key: 'this_year',
    value: 'This year (Year to date)',
    date: [moment().startOf('year'), moment().endOf('day')],
  },
  {
    key: 'last_week',
    value: 'Last week',
    date: [
      moment().subtract(1, 'weeks').startOf('isoWeek'),
      moment().subtract(1, 'weeks').endOf('isoWeek'),
    ],
  },
  {
    key: 'last_month',
    value: 'Last month',
    date: [
      moment().subtract(1, 'months').startOf('month'),
      moment().subtract(1, 'months').endOf('month'),
    ],
  },
  { key: 'custom', value: 'Custom', date: [] },
]

export const DATE_FORMAT = 'yyyy-MM-DD'
export const DATE_FORMAT_FROM_DISPLAY = 'DD MMM YYYY'
export const DEFAULT_CHART_BG_COLOR = 'rgb(132, 132, 132)'
